import React, { useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '../common/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import dialogStyles from './styles';
import { registerseller, getCountriesList } from '../../actions/login';
import Loader from '../common/Loader';
import FormValidator from '../../utils/validator';
import { toast } from 'react-toastify';
import { connect } from "react-redux";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});


const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const Register = (props) => {
  const { classes, handleClose } = props;
  const [countries, setCountries] = useState([]);
  useEffect(() => {
    getCountriesList().then((response) => {
      setCountries(response.data.details.countries);
    })
  }, []);

  const [seller, setSeller] = useState({
    businessName: "",
    emailId: "",
    countryId: "",
    mobileNo: ""
  });

  const schema = [
    {
      field: 'businessName',
      method: ['isEmpty'],
      validWhen: false,
      message: 'Name is required.',
    },
    {
      field: 'emailId',
      method: ['isEmail'],
      validWhen: true,
      message: 'Enter a valid email.',
    },
    {
      field: 'countryId',
      method: ['isEmpty'],
      validWhen: false,
      message: 'Select Country Code',
    },
    {
      field: 'mobileNo',
      method: ['matches'],
      args: [/^\d{10}$/],
      validWhen: true,
      message: 'Enter a valid mobile number.',
    }

  ];


  const [errors, setErrors] = useState(null);
  const validator = new FormValidator(schema);
  const [isLoading, setLoading] = useState(false);

  const handleChange = (key, e) => {
    setSeller({
      ...seller,
      [key]: e.target.value
    })

  }

  const registerSeller = () => {
    const err = validator.validate({ ...seller });
    setErrors(err);
    if (!err.isValid) {
      return;
    }
    setLoading(true);
    const sellerDet = {
      businessName: seller.businessName,
      countryId: seller.countryId,
      emailId: seller.emailId,
      mobileNo: seller.mobileNo
    };
    registerseller(sellerDet, (message, isError) => {
      const method = isError ? 'error' : 'success';
      toast[method](message);
      setLoading(false);
      if (!isError) {
        handleClose();
      }
    })
  };

  return (
    <div className={classes.container}>
      {isLoading && <Loader />}
      <TextField
        label="Restaurant / Chef Name"
        name="businessName"
        onChange={(e) => handleChange('businessName', e)}
        variant="outlined"
        classes={{ root: classes.input }}
        value={seller.businessName}
        error={errors && errors.businessName && errors.businessName.isInvalid}
        helperText={errors && errors.businessName && errors.businessName.isInvalid && errors.businessName.message}
      />
      <TextField
        label="Email"
        name="emailid"
        placeholder="Enter Email"
        onChange={(e) => handleChange('emailId', e)}
        variant="outlined"
        classes={{ root: classes.input }}
        value={seller.emailId}
        error={errors && errors.emailId && errors.emailId.isInvalid}
        helperText={errors && errors.emailId && errors.emailId.isInvalid && errors.emailId.message}
      />
      <FormControl classes={{ root: classes.input }}>
        <InputLabel shrink id="demo-simple-select-placeholder-label-label">
        </InputLabel>
        <Select
          labelId="demo-simple-select-placeholder-label-label"
          id="demo-simple-select-placeholder-label"
          name="countryId"
          variant="outlined"
          value={seller.countryId}
          onChange={(e) => handleChange("countryId", e)}
          displayEmpty
          classes={{ select: classes.inputRoot }}
          error={errors && errors.countryId && errors.countryId.isInvalid}
        >
          <MenuItem value="">
            <em>Select Country</em>
          </MenuItem>
          {countries.map((option) => (
            <MenuItem key={option.countryId} value={option.countryId}>
              {option.countryName}
            </MenuItem>
          ))}
        </Select>
        <div style={{ color: 'red' }}>{errors && errors.countryId && errors.countryId.isInvalid && errors.countryId.message}</div>
      </FormControl>
      <TextField
        label=" Phone Number"
        name="mobileNo"
        placeholder="Enter Phone Number"
        onChange={(e) => handleChange('mobileNo', e)}
        variant="outlined"
        classes={{ root: classes.input }}
        value={seller.mobileNo}
        error={errors && errors.mobileNo && errors.mobileNo.isInvalid}
        helperText={errors && errors.mobileNo && errors.mobileNo.isInvalid && errors.mobileNo.message}
      />
      <div className={classes.register} style={{ justifyContent: 'center' }}>
        <Button label={'Add Seller'} onClick={registerSeller} color="primary" />
      </div>
    </div>
  )
}
const Reg = connect(store => store)(Register);
const SignUp = withStyles(dialogStyles)(Reg);
const CustomizedDialogs = (props) => {
  const { classes } = props;
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Button size="small"
        label="Seller Details"
        className={'ml-auto sellerDt'} onClick={handleClickOpen}>
      </Button>
      <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open} scroll={'body'} >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Food seller details
        </DialogTitle>
        <DialogContent dividers>
          <SignUp handleClose={handleClose} />
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default withStyles(dialogStyles)(CustomizedDialogs);
